import PushNotifications from 'views/PushNotifications/PushNotifications';
import PushNotificationDetails from 'views/PushNotifications/PushNotificationDetails';
import ContactCenters from 'views/ContactCenters/ContactCenters';
import ContactCentersDetails from 'views/ContactCenters/ContactCentersDetails';
import ContactCenterCreate from 'views/ContactCenters/ContactCenterCreate';
import CustomerRegistrations from 'views/CustomerRegistrations/CustomerRegistrations';
import CustomerRegistrationsDetails from 'views/CustomerRegistrations/CustomerRegistrationsDetails';
import Configuration from 'views/Configuration/Configuration';
import RegisterPage from 'views/Pages/RegisterPage';
import LoginPage from 'views/Pages/LoginPage';
import LockScreenPage from 'views/Pages/LockScreenPage';
import ChangePasswordPage from 'views/Pages/ChangePasswordPage';
import UserPasswordResetPage from 'views/Pages/UserPasswordResetPage';
import Alerts from 'views/Alerts/Alerts';
import Reports from 'views/Reports/Reports';
import Users from 'views/Users/Users';
import UserProfilePage from 'views/Pages/UserProfilePage';
import Scheduler from 'views/Scheduler/Scheduler';
import VacationForm from 'views/Scheduler/VacationForm';
import CreateScheduledCall from 'views/Scheduler/CreateScheduledCall';
import EditAppointment from 'views/Scheduler/EditAppointment';
import MarketingPage from 'views/Marketing/MarketingPage';
import MarketingEventLogDetails from 'views/Marketing/MarketingEventLogDetails';
import BillingReport from 'views/BillingReport/BillingReport';
import Thresholds from 'views/Thresholds/Thresholds';
import Licensing from 'views/Licensing/Licensing';

// @material-ui/icons
import NotificationsNoneOutlined from '@material-ui/icons/NotificationsNoneOutlined';
import BusinessOutlined from '@material-ui/icons/BusinessOutlined';
import SettingsOutlined from '@material-ui/icons/SettingsOutlined';
import PieChartOutlinedIcon from '@material-ui/icons/PieChartOutlined';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import UsersIcon from 'components/Icons/Users';

import { ReactComponent as AdminPanelIconOutlined } from 'assets/img/Menu_AdminPanel.svg';
import { ReactComponent as BillingReportIconOutlined } from 'assets/img/Menu_BillingReport.svg';
import { ReactComponent as MarketingIcon } from 'assets/img/Menu_Marketing.svg';
import { ReactComponent as ThresholdsIcon } from 'assets/img/Menu_Thresholds.svg';
import { ReactComponent as CustomerRegistrationsIcon } from 'assets/img/CustomerRegistrations.svg';
import { ReactComponent as LicensingIcon } from 'assets/img/Menu_Licensing.svg';

import permissionsMap from 'utils/permissions/permissionsMap';
import layoutNames from 'utils/enums/layout-names.enum';

const dashRoutes = [
	{
		path: '/register',
		component: RegisterPage,
		layout: `/${layoutNames.auth}`,
	},
	{
		path: '/login',
		component: LoginPage,
		layout: `/${layoutNames.auth}`,
	},
	{
		path: '/change-password',
		component: ChangePasswordPage,
		layout: `/${layoutNames.auth}`,
	},
	{
		path: '/user-password-reset',
		component: UserPasswordResetPage,
		layout: `/${layoutNames.auth}`,
	},
	{
		path: '/lock',
		component: LockScreenPage,
		layout: `/${layoutNames.auth}`,
	},
	{
		path: '/profile',
		component: UserProfilePage,
		layout: `/${layoutNames.portal}`,
	},
	{
		path: '/push-notifications',
		name: 'Push Notifications',
		icon: NotificationsNoneOutlined,
		component: PushNotifications,
		layout: `/${layoutNames.portal}`,
		isMenuItem: true,
		allowedFor: permissionsMap.pushNotificationsLog.items.pushNotificationsLog.read,
		views: [
			{
				path: '',
				name: 'Push Notifications',
				component: PushNotifications,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.pushNotificationsLog.items.pushNotificationsLog.read,
			},
			{
				path: '/details/:id',
				name: 'Push Notification Details',
				component: PushNotificationDetails,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.pushNotificationsLog.items.pushNotificationsLog.read,
			},
		],
	},
	{
		path: '/contact-centers',
		name: 'Contact Centers',
		icon: BusinessOutlined,
		component: ContactCenters,
		layout: `/${layoutNames.portal}`,
		isMenuItem: true,
		allowedFor: permissionsMap.contactCenter.items.contactCenter.read,
		views: [
			{
				path: '',
				name: 'Contact Centers',
				component: ContactCenters,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.contactCenter.items.contactCenter.read,
			},
			{
				path: '/details/:id',
				name: 'Contact Centers Details',
				component: ContactCentersDetails,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.contactCenter.items.contactCenter.read,
			},
			{
				path: '/create',
				name: 'Customer Registrations Details',
				component: ContactCenterCreate,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.contactCenter.items.contactCenter.create,
			},
		],
	},
	{
		path: '/customer-registrations',
		name: 'Customer Registrations',
		icon: CustomerRegistrationsIcon,
		component: CustomerRegistrations,
		layout: `/${layoutNames.portal}`,
		isMenuItem: true,
		allowedFor: permissionsMap.customerRegistration.items.customerRegistrationInformationView.read,
		views: [
			{
				path: '',
				name: 'Customer Registrations',
				component: CustomerRegistrations,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.customerRegistration.items.customerRegistrationInformationView.read,
			},
			{
				path: '/details/:id',
				name: 'Customer Registrations Details',
				component: CustomerRegistrationsDetails,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.customerRegistration.items.customerRegistrationInformationView.read,
			},
		],
	},
	{
		path: '/alerts',
		name: 'Alerts',
		component: Alerts,
		layout: `/${layoutNames.portal}`,
		isMenuItem: false,
		views: [
			{
				path: '',
				name: 'Alerts',
				component: Alerts,
				layout: `/${layoutNames.portal}`,
			},
		],
	},
	{
		path: '/reports',
		name: 'Dashboards & Analytics',
		icon: PieChartOutlinedIcon,
		component: Reports,
		layout: `/${layoutNames.portal}`,
		isMenuItem: true,
		licensesFeatureName: 'analytics.view',
		allowedFor: permissionsMap.statistics.items.executiveDashboard.read,
		views: [
			{
				path: '',
				name: 'Reports',
				component: Reports,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.statistics.items.executiveDashboard.read,
			},
		],
	},
	{
		path: '/scheduler',
		name: 'Scheduler',
		icon: CalendarTodayIcon,
		component: Scheduler,
		layout: `/${layoutNames.portal}`,
		isMenuItem: true,
		licensesFeatureName: 'scheduler.scheduleCall',
		allowedFor: permissionsMap.scheduler.items.calendarViewForUser.read,
		views: [
			{
				path: '',
				name: 'Scheduler',
				component: Scheduler,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.scheduler.items.calendarViewForUser.read,
			},
			{
				path: '/create-vacation',
				name: 'Vacation form',
				component: VacationForm,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.scheduler.items.scheduleCall.create,
			},
			{
				path: '/vacation/:id',
				name: 'Vacation form',
				component: VacationForm,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.scheduler.items.scheduleCall.update,
			},
			{
				path: '/create-call',
				name: 'Create Call',
				component: CreateScheduledCall,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.scheduler.items.scheduleCall.create,
			},
			{
				path: '/call/:id',
				name: 'Call form',
				component: EditAppointment,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.scheduler.items.scheduleCall.update,
			},
		],
	},
	{
		path: '/marketing',
		name: 'Marketing',
		icon: MarketingIcon,
		component: MarketingPage,
		layout: `/${layoutNames.portal}`,
		isMenuItem: true,
		licensesFeatureName: { $or: ['marketing.multicast', 'marketing.broadcast', 'marketing.unicast'] },
		allowedFor: permissionsMap.marketing.items.broadcast.read,
		views: [
			{
				path: '',
				name: 'Marketing',
				component: MarketingPage,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.marketing.items.broadcast.read,
			},
			{
				path: '/event-logs',
				name: 'Marketing',
				component: MarketingPage,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.marketing.items.broadcast.read,
			},
			{
				path: '/details/:id',
				name: 'EventLogs',
				component: MarketingEventLogDetails,
				layout: `/${layoutNames.portal}`,
				allowedFor: permissionsMap.marketing.items.broadcast.read,
			},
		],
	},
	{
		collapse: true,
		name: 'Admin Panel',
		icon: AdminPanelIconOutlined,
		state: "adminPanelCollapse",
		isMenuItem: true,
		allowedFor: permissionsMap.adminPanel.items.adminPanel.read,
		views: [
			{
				path: '/users',
				name: 'Users Management',
				icon: UsersIcon,
				component: Users,
				layout: `/${layoutNames.portal}`,
				isMenuItem: true,
				allowedFor: permissionsMap.adminPanel.items.userManagement.read,
				views: [
					{
						path: '',
						name: 'Users',
						component: Users,
						layout: `/${layoutNames.portal}`,
						allowedFor: permissionsMap.adminPanel.items.userManagement.read,
					},
				],
			},
			{
				path: '/configuration',
				name: 'Configurable parameters',
				icon: SettingsOutlined,
				component: Configuration,
				layout: `/${layoutNames.portal}`,
				isMenuItem: true,
				allowedFor: permissionsMap.adminPanel.items.configurationPanel.read,
			},
			{
				path: '/billing-report',
				name: 'Billing Report',
				icon: BillingReportIconOutlined,
				component: BillingReport,
				layout: `/${layoutNames.portal}`,
				isMenuItem: true,
				allowedFor: permissionsMap.adminPanel.items.billingReport.read,
			},
			{
				path: '/licensing',
				name: 'Licensing',
				icon: LicensingIcon,
				component: Licensing,
				layout: `/${layoutNames.portal}`,
				isMenuItem: true,
				allowedFor: permissionsMap.adminPanel.items.licensing.read,
			},
			{
				path: '/thresholds',
				name: 'Thresholds',
				icon: ThresholdsIcon,
				component: Thresholds,
				layout: `/${layoutNames.portal}`,
				isMenuItem: true,
				allowedFor: permissionsMap.adminPanel.items.reportThresholds.read,
				licensesFeatureName: 'analytics.alarms',
			},
		],
	},
];

export default dashRoutes;
